<template>
    <v-dialog width="500px" v-model="isVisible" persistent>
        <v-card>
            <v-card-title class="headline primary darken-2 white--text" primary-title>
                <i class="fas fa-hourglass-half mr-2"></i>Verification in Progress
            </v-card-title>
            <v-card-text class="pa-4">
                <div class="text-xs-center">
                    <i class="fas fa-sync-alt fa-spin teal--text" style="font-size: 40px; margin-bottom: 20px;"></i>
                </div>
                <p class="mb-0">
                    <b>Verification in progress:</b> Your payment request is currently being processed by our system.
                </p>

                <p class="mb-0 mt-2">
                    You may safely close this page. Your payment status will be updated automatically once verification is completed.
                </p>

                <p class="mb-0 mt-3 teal--text darken-2">
                    <b>Amount:</b> {{ verificationData.amount }} F CFA
                </p>

                <p class="mb-0 teal--text darken-2">
                    <b>Operator:</b> {{ verificationData.operator }}
                </p>

                <p class="mb-0 teal--text darken-2">
                    <b>Phone:</b> {{ verificationData.phoneNumber }}
                </p>
            </v-card-text>

            <v-card-actions class="px-3">
                <v-spacer></v-spacer>
                <v-btn color="teal darken-2" class="white--text" @click="closePopup()" > OK </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PaymentVerificationPopup',
    computed: {
        isVisible: {
            get() {
                return this.$store.state.paymentVerificationVisible;
            },
            set(value) {
                if (!value) {
                    this.closePopup();
                }
            }
        },
        verificationData() {
            return this.$store.state.paymentVerificationData;
        }
    },
    mounted() {
        // Restore verification status if page is reloaded
        this.$store.commit('restorePaymentVerification');
    },
    methods: {
        closePopup() {
    const { feature, id } = this.$store.state.paymentVerificationData;

    let redirectUrl = '/';

    if (feature === 'savings_campaign') {
        redirectUrl = `/savings/campaigns/detail/${id}/`;
    } else if (feature === 'njangi') {
        redirectUrl = `/njangi/groups/detail/${id}/`;
    } else if (feature === 'marketplace') {
        redirectUrl = `/market_place/campaign/detail/${id}/`;
    } else if (feature === 'marketplace_payment_deposit') {  // ← AJOUTER CE CAS
        redirectUrl = `/market_place/shopping_bag/items/transactions/`;
    } else if (feature === 'loan') {
        redirectUrl = `/savings/loans/detail/${id}/`;
    } else if (feature === 'investment') {
        this.$store.commit('hidePaymentVerification');
        this.$router.push({
            name: 'SavingsInvestismentDetail',
            params: { investment_id: id }
        });
        return;
    }

    this.$store.commit('hidePaymentVerification');
    if (redirectUrl !== '/') {
        this.$router.push(redirectUrl);
    }
}
    }
}
</script>

